<template>
  <div>
    <div>
      <slot name="filters" v-bind="{filter_by,filter:myRequestStatus_filter}"></slot>
    </div>
    
    <v-row v-if="!no_title">
      <v-col :md="title_md">
        <h2 class="tableTitle">
          <slot name="crud-title"></slot>
        </h2>
      </v-col>
      <v-col :md="sc_btns_md" class="sc-btns">
        <slot name="btns">
          <slot name="extra-btns"></slot>
          <slot name="add-btn">
            <v-btn color="primary" @click="newItem" small  v-if="canAdd"><!-- class="btn-radius" outlined -->
              <v-icon>add</v-icon>
              <span>Agregar</span>
            </v-btn>
          </slot>
        </slot>
      </v-col>
    </v-row>

    <v-data-table
      disable-sort
			:headers="headers"
			:items="computedRows"
      disable-pagination
      :loading="requestStatus_status=='getting'"
      loading-text="Cargando... "
      hide-default-footer
			class="tablaLT1"
      :item-key="item_key"
			:expanded.sync="expanded"
			:show-expand="expandable"
			:class="dark_t?'dark':''">
      <template v-slot:body="{ items}">
        <tbody>
          <template v-for="(item,i) in items">
            <tr :key="`A-${i}`">
              <fs1 tag="td" v-if="expandable">
                <slot name="expand_icon" v-bind="{item,expanded,expand,is_expanded:is_expanded(item)}">
                  <v-icon @click="expand(item)">
                    {{is_expanded(item) ? 'expand_more': 'chevron_right'}}
                  </v-icon>
                </slot>
              </fs1>
              <template v-for="(v, h_i) in hearder_array">  
                <slot :name="v" v-bind="{value:item[v], item, items, itemDetail, writeItem, askForDelete,disabled,ask_for_toggle}">
                  <fs1 tag="td" :key="h_i" :class="headers[h_i].class||''" >
                    <template v-if="v == 'actions'">
                      <template v-if="actions3ds">
                        <div class="actions">
                          <v-menu :close-on-click="true" :offset-y="true">
                            <template v-slot:activator="{ on }"><v-icon v-on="on">more_vert</v-icon></template>
                            <v-list>
                              <v-list-item @click="askForDelete(item)" v-if="canDelete" :disabled="disabled('delete',item)">
                                <v-icon>delete</v-icon>
                                <span>Eliminar</span>
                              </v-list-item>
                              <v-list-item @click="itemDetail(item)" v-if="canDetail" :disabled="disabled('detail',item)">
                                <v-icon>description</v-icon>
                                <span>Ver ficha</span>
                              </v-list-item>
                              <v-list-item @click="writeItem(item)" v-if="canWrite" :disabled="disabled('edit',item)">
                                <v-icon>edit</v-icon>
                                <span>Editar</span>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </template>
                      <template v-else>
                        <v-icon class="ma-1 pointer" @click="itemDetail(item)" v-if="canDetail" :disabled="disabled('detail',item)">account_box</v-icon>
                        <v-icon class="ma-1 pointer" @click="writeItem(item)" v-if="canWrite" :disabled="disabled('edit',item)">edit</v-icon>
                        <v-icon class="ma-1 pointer" @click="askForDelete(item)" v-if="canDelete" :disabled="disabled('delete',item)">delete</v-icon>
                      </template>
                    </template>
                    <template v-else>
                      <a v-if="var_type(v) === 'file'" href="#" class="tableM1_file" @click.prevent="openFileField(item, v)">
                        <v-icon >insert_drive_file</v-icon>
                      </a>
                      <template v-else>{{item[v]}}</template>
                    </template>
                  </fs1>
                </slot>
              </template>
            </tr>
            <tr v-if="is_expanded(item)" :key="`B-${i}`">
              <fs1 tag="td" :colspan="hearder_array.length+1">
                <slot name="expanded" v-bind="{item}">---</slot>
              </fs1>
            </tr>
          </template>
          <tr v-if="items.length === 0">
            <fs1 tag="td" :colspan="hearder_array.length+1">
              <v-icon>warning</v-icon>
              Sin Información.
            </fs1>
          </tr>
        </tbody>
      </template>
		</v-data-table>
    <!-- {{name_all_computed}}-{{navegation}} -->
    <Navegation v-if="pagination && navegation" :selectedItem.sync="navegation" :pageChange="pageChange"/>


    <v-dialog v-model="dialogDetail" :width="'80%'">
			<v-card class="fullHeight pa-20" v-if="dialogDetail">
        <slot name="detail-header" v-bind:close_dialog_detail="close_dialog_detail">
          <div>
            <h2 class="dialogTitle"><slot name="detail-title"></slot></h2>
            <v-icon class="closeDialog" v-on:click="close_dialog_detail()">close</v-icon>
          </div>
        </slot>
        <slot name="detail" v-bind:selectedItem="selectedItem"></slot>
        
				<div style="text-align: center">
					<v-btn color="secondary" @click="close_dialog_detail()" class="ma-4">
						<v-icon>close</v-icon>
						<span>Cerrar</span>
					</v-btn>
				</div>
			</v-card>
    </v-dialog>

    <v-dialog v-model="dialogWrite" :width="dialogWriteWdith || '50%'">
      <!-- v-if es para q se muera el componente si es false, de esa manera reinicia cada vez que se habre sin tener datos que quedaron antes de la vez anterior -->
			<v-card class="fullHeight pa-20" v-if="dialogWrite">
        <!-- <div>
          <h2 class="dialogTitle"><slot name="write-title"></slot></h2>
          <v-icon class="closeDialog" v-on:click="dialogWrite = false">close</v-icon>
        </div> -->
        <template1>
          <template slot="title">
            <slot name="write-title" v-bind="{selectedItem}"></slot>
          </template>
          <template slot="extra">
            <v-icon class="closeDialog" v-on:click="dialogWrite = false">close</v-icon>
          </template> 
        </template1>
        <slot name="write" v-bind="{save:check_and_save,selectedItem,closeDialogWrite,items:computedRows}"></slot>

				
        <slot name="write-btns" v-bind="{save:check_and_save,selectedItem,closeDialogWrite}">
          <div style="text-align: center; margin-top:30px" v-show="show_write_btns">
            <v-btn color="secondary" @click="closeDialogWrite" class="ma-4">
              <v-icon>close</v-icon>
              <span>Cancelar</span>
            </v-btn>
            <v-btn color="primary" @click="check_and_save" class="ma-4">
              <v-icon class="mr-1">
                <slot name="write-btns-save-icon">save</slot>
              </v-icon>
              <span>
                <slot name="write-btns-save-text">Guardar</slot>
              </span>
            </v-btn>
          </div>
        </slot>
				
			</v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" :width="'50%'">
			<v-card class="fullHeight pa-20">
        <template1>
          <template slot="title">
            <slot name="delete-title" v-bind="{selectedItem}">Eliminar</slot>
          </template>
          <template slot="extra">
            <v-icon class="closeDialog" v-on:click="deleteDialog = false">close</v-icon>
          </template> 
        </template1>
        <div>
          <slot name="deleteAsk" v-bind:selectedItem="selectedItem">{{selectedItem.name||''}}</slot>
        </div>
				<div style="text-align: center; margin-top: 30px">
					<v-btn color="secondary" @click="deleteDialog = false" class="ma-4">
						<v-icon>reply</v-icon>
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary"  @click="deleteItem(selectedItem)" class="ma-4">
						<v-icon>delete</v-icon>
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
    </v-dialog>

    <v-dialog v-model="toggle_dialog" :width="'50%'">
			<v-card class="fullHeight pa-20">
        <template1>
          <template slot="title">
            <slot name="toggle-title" v-bind="{selectedItem}">Eliminar</slot>
          </template>
          <template slot="extra">
            <v-icon class="closeDialog" v-on:click="toggle_dialog = false">close</v-icon>
          </template> 
        </template1>
        <div>
          <slot name="toggle-ask" v-bind:selectedItem="selectedItem">{{selectedItem.name||''}}</slot>
        </div>
				<div style="text-align: center; margin-top: 30px">
					<v-btn color="secondary" @click="toggle_dialog = false" class="ma-4">
						<v-icon>reply</v-icon>
						<span>Cancelar</span>
					</v-btn>
          <slot name="toggle-btn" v-bind="{selectedItem,toggle_item,toggle_key}">
            <v-btn color="primary"  @click="toggle_item(selectedItem,toggle_key)" class="ma-4">
              <span>Aceptar</span>
            </v-btn>
          </slot>
				</div>
			</v-card>
    </v-dialog>

    <v-dialog v-model="dialogCustom" :width="'50%'">
			<v-card class="fullHeight pa-20">
        <slot name="dialog-custom" ></slot>
        <slot name="dialog-custom" v-bind:slotprops="{ closeDialogCustom}"></slot>
			</v-card>
    </v-dialog>

  </div>
</template>

<script>
import CustomCrud from '../CustomCrud.js';
import Debounce from '@/components/Debounce.js';
import navegation_compl from '../../Navegation.js'

export default {
  mixins: [ CustomCrud, Debounce, navegation_compl ],
  props:{
    actions3ds:{default:false},
    expandable:{default:false},
    permissions:{default:()=>{return{}}},
    conditions:{default:()=>{return{}}},
    pagination:{default:true},
    headers:{},
    item_key:{default:'id'},
    created_cache:{default:true},
    no_title:{default:false},
    title_md:{default:5},
    sc_btns_md:{default:7},
  },
  data() {
    return {
      expanded:[],
      /* expanded_items:[], */
      gets_on_created:true,
    };
  },
  computed: {
    hearder_array () { return Object.keys(this.headers).map(i => this.headers[i].value) },
  },
  watch:{ },
  methods: {
    close_dialog_detail(){ this.dialogDetail = false },
    filterF(){
      return this.filter;
    },
    disabled(key,item){
      if (this.conditions[key] && this.conditions[key](item)) return true;
      if (this.permissions[key]) return !this.myPermissions.includes(this.permissions[key]);
      return false;
    },
    expand(item,pre_expand){
      if (this.is_expanded(item)) this.expanded.splice(this.expanded.indexOf(item),1);
      else {
        if (pre_expand) pre_expand(item);
        this.expanded.push(item);
      }
    },
    is_expanded(item) { return this.expanded.indexOf(item) > -1},
    openFileField(item, field) {
      if (this.$listeners && this.$listeners['open-file']) {
        this.$emit('open-file', item, field);
        return;
      }
      const href = item && item[field];
      if (href) window.open(href, '_blank', 'noopener,noreferrer');
    },
  },
};
</script>
<style scoped>
.closeDialog{
  float: right;
}
</style>